import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DeleteConfirmationDialog = ({
  visible,
  onConfirm,
  onCancel,
  loading = false,
  heading = "Are you sure you want to delete this Shareholder Profile?",
  description = "Deleting this will remove the shareholder's profile, including all associated transactions across this and any linked entities.",
}) => {
  return (
    <Dialog
      visible={visible}
      style={{ width: "50vw" }}
      className="edit-contact-dialog"
      onHide={onCancel}
    >
      <p className="del-dialog-heading">{heading}</p>

      <p className="del-dialog-para">{description}</p>

      <div className="flex justify-content-end gap-2 mt-4">
        <button className="cancel-btns" onClick={onCancel}>
          Cancel
        </button>
        <Button
          label={loading ? "Yes, Delete" : "Yes, Delete"}
          severity="danger"
          loading={loading}
          onClick={onConfirm}
        />
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
